import React, { useState } from 'react'
import Cover from './Cover/Cover'
import Savethedate from '../../FinalOutput/Components/SaveTheDate/Savethedate'
import Countdown from '../../FinalOutput/Components/Countdown/Countdown'
import Couple from './Couple/Couple'
import Events from '../../FinalOutput/Components/Events/Events'
import Rsvpfooter from '../../FinalOutput/Components/RSVP&Footer/Rsvpfooter'
import Envelope from '../../FinalOutput/Components/Envelope/Envelope'
import { useSelector } from 'react-redux'
import Trialbadge from '../../../helpers/Trialbadge'
import Watermark from '../../../helpers/Watermark'
import Sliderpre from './Slider/Sliderpre'
import PhotoControls from '../../../helpers/PhotoControls'
import PreviewMark from '../../../helpers/PreviewMark'
import MusicButton from '../../../helpers/MusicButton'



const Theme1 = ({details,events,isPreview,demoExpired,photoControls,playMusic,toggleMusic,isMusicPlaying}) => {
      const {user} = useSelector(state => state.auth);
  const [envelopeScreen, SetEnvelopeScreen] = useState(true)
  const [photoMode, setPhotoMode] = useState();

  return (
    <>
  


    {isPreview && <PreviewMark />}



{!isPreview && user?.demoVersion && !demoExpired && (
  <Trialbadge demoExpiryTime={user.demoExpiryTime} />
)}

{!isPreview && user?.demoVersion && !demoExpired && (
  <Watermark />
)}

{photoControls && !envelopeScreen && (
        <PhotoControls
          photoMode={photoMode}
          setPhotoMode={setPhotoMode}
        />
      )}

    {envelopeScreen ?  <Envelope  SetEnvelopeScreen={SetEnvelopeScreen}  details={details}  demoExpired={demoExpired}  onOpen={playMusic} /> : <>
      

      <MusicButton
  enabled={details.music?.enabled}
  isMusicPlaying={isMusicPlaying}
  toggleMusic={toggleMusic}
  theme={details?.theme}
/>
     
      <Cover details={details}  photoMode={photoMode} />
    <Savethedate details={details} />
    <Countdown  details={details}/>
    <Couple  details={details}   photoMode={photoMode} />
    <Events  events={events} theme={details?.theme} />
    <Sliderpre  details={details} />
    <Rsvpfooter   details={details}  isPreview={isPreview} /> 
     </> }
     </>
  )
}

export default Theme1